import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectFilters = ({ 
  activeFilter, 
  onFilterChange, 
  activeIndustry, 
  onIndustryChange,
  projectCount,
  types = [],
  industries = []
}) => {
  // Map strings to {label, value} objects for the UI
  const typeOptions = [
    { label: 'All', value: 'all' },
    ...types.map(t => ({ label: t, value: t }))
  ];

  const industryOptions = [
    { label: 'All', value: 'all' },
    ...industries.map(i => ({ label: i, value: i }))
  ];

  return (
    <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl p-6 mb-8 shadow-2xl">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading font-semibold text-xl text-text-primary">
          Filter Projects
        </h2>
        <div className="flex items-center space-x-2 text-text-muted">
          <Icon name="Filter" size={16} />
          <span className="text-sm">{projectCount} projects found</span>
        </div>
      </div>

      {/* Project Type Filters */}
      <div className="mb-6">
        <h3 className="font-heading font-medium text-sm text-text-secondary mb-3 uppercase tracking-wide">
          Project Type
        </h3>
        <div className="flex flex-wrap gap-2">
          {typeOptions.map((option) => (
            <Button
              key={option.value}
              variant={activeFilter === option.value ? 'primary' : 'ghost'}
              size="sm"
              onClick={() => onFilterChange(option.value)}
              className={`transition-smooth border ${activeFilter === option.value ? 'border-accent' : 'border-white/10 hover:border-accent/30'} ${activeFilter === option.value ? '' : 'bg-white/5'}`}
            >
              {option.label}
            </Button>
          ))}
        </div>
      </div>

      {/* Industry Filters */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="font-heading font-medium text-sm text-text-secondary mb-3 uppercase tracking-wide">
            Industry / Domain
          </h3>
          <div className="relative">
          <select
            value={activeIndustry}
            onChange={(e) => onIndustryChange(e.target.value)}
            className="w-full appearance-none bg-white/5 border border-white/10 rounded-lg px-4 py-2.5 text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-smooth"
          >
            {industryOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <Icon name="ChevronDown" size={16} className="text-text-muted" />
            </div>
          </div>
        </div>

        {/* Clear Filters (Repurposed area) */}
        <div className="flex items-end">
           {(activeFilter !== 'all' || activeIndustry !== 'all') && (
            <Button
              variant="text"
              size="sm"
              iconName="X"
              iconPosition="left"
              onClick={() => {
                onFilterChange('all');
                onIndustryChange('all');
              }}
              className="text-text-muted hover:text-text-primary mb-1"
            >
              Clear All Filters
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectFilters;